<div
	ngbDropdown
	class="btn-group"
	role="group"
	aria-label="Button group with nested dropdown"
>
	<button
		class="btn btn-secondary dropdown-toggle w-100 text-start"
		id="languageDropdown"
		ngbDropdownToggle
	>
		{{ currentLanguage }}
	</button>
	<div ngbDropdownMenu aria-labelledby="languageDropdown">
		@for (language of availableLanguages; track language.id) {
			<button
				ngbDropdownItem
				(click)="selectLanguage(language)"
				[class.active]="isLanguageSelected(language)"
			>
				{{ language.displayName }}
			</button>
		}
	</div>
</div>
